export const SOCKET_GLOBAL = 'SOCKET_GLOBAL'